<template>
  <div>
    <v-container>
      <v-row no-gutters>
        <v-col cols="12">
          <h4>
            {{ $t("REGISTER_OF_CERTIFICATE_OF_RELEASE_FOR_THE_SALE_OF_FINAL_PRODUCT") }}
          </h4>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="headers.search"
            prepend-inner-icon="search"
            clearable
            :label="$t('SEARCH')"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <div class="form-group">
            <label for="">
              <span> {{ $t("START_DATE") }}:</span>
            </label>
            <div class="field-wrap">
              <datetime
                zone="local"
                value-zone="local"
                type="date"
                v-model="headers.start_date"
                input-class="form-control"
              ></datetime>
            </div>
          </div>
        </v-col>
        <v-col cols="3">
          <div class="form-group">
            <label for="">
              <span> {{ $t("END_DATE") }}:</span>
            </label>
            <div class="field-wrap">
              <datetime
                zone="local"
                value-zone="local"
                type="date"
                v-model="headers.end_date"
                input-class="form-control"
              ></datetime>
            </div>
          </div>
        </v-col>
        <v-col
          cols="3"
          class="d-flex justify-content-center align-items-center"
        >
          <div v-on:click="downloadData()" class="btn btn-primary">
            {{ $t("DOWNLOAD_EXPORT") }}
          </div>
        </v-col>
      </v-row>

      <v-row class="mb-6 t-header">
        <template v-for="column of headers.columns">
          <v-col
            :key="column.name"
            :cols="column.cols"
            v-if="column.hide != true"
          >
            <span @click="changeOrder(column.name)">
              {{ $t("LABELS." + column.name) }}
              <span v-if="column.name == headers.order">{{
                orderIcon
              }}</span></span
            >
          </v-col>
        </template>
        <v-col cols="1">
          {{ $t("OPERATIONS") }}
        </v-col>
      </v-row>

      <div v-show="!isLoadingFinalProductSaleRegister">
        <v-row class="mb-6 t-row" v-for="item of items" :key="item.id">
          <template v-for="col of headers.columns">
            <v-col
              class="t-col"
              :key="col.name"
              :cols="col.cols"
              v-if="col.hide != true"
            >
              <template v-if="col.name === 'routeMap.certificate.signedAt'">
                {{ dateFormat(item[col.name]) }}
              </template>
              <template v-else>
                {{ item[col.name] }}
              </template>
            </v-col>
          </template>
          <v-col class="t-col" cols="1">
            <DownloadPdfButton
              :id="item['routeMap.certificate.id']"
              file-type="product-certificate"
              :text="$t('DOWNLOAD_CERTIFICATE')"
              list-action="finalProductSaleRegisterList"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col class="text-right">
            {{ totalItems }} {{ $t("RESULTS") }}
          </v-col>
        </v-row>
      </div>

      <v-progress-linear
        class="mt-5"
        color="#25bdad"
        buffer-value="0"
        stream
        reverse
        :active="isLoadingFinalProductSaleRegister"
      ></v-progress-linear>

      <Paginator
        :totalPages="totalPages"
        :page="headers.page"
        :maxVisibleButtons="tableOptions.maxVisibleButtons"
        @change-page="changePage"
      />
    </v-container>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";

import ListMixin from "@/common/mixins/List";
import Paginator from "@/components/Paginator";

import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import DownloadPdfButton from "@/components/ActionButtons/DownloadPdfButton";

import {
  GET_ALL_FINAL_PRODUCT_SALE_REGISTER,
  DOWNLOAD_FINAL_PRODUCT_SALE_REGISTER
} from "@/store/finalProductSaleRegister.module";

import { mapGetters } from "vuex";
import { API_URL } from "@/common/config";

export default {
  name: "FinalProductSaleList",
  components: { Paginator, DownloadPdfButton },
  mixins: [ListMixin],
  data() {
    return {
      startLoading: true,
      error_messages: {},
      search: "",
      action: "finalProductSaleRegister",
      tableOptions: {
        showSearch: false,
        draggableCols: true,
        selectable: true,
        rowsPerPage: [2, 10, 20, 50],
        maxVisibleButtons: 5
      },
      headers: {
        columns: [
          {
            name: "routeMap.certificate.id",
            cols: "1"
          },
          {
            name: "documentType",
            cols: "2"
          },
          {
            name: "routeMap.certificateNumber.number",
            cols: "2"
          },
          {
            name: "routeMap.product.name",
            search: "",
            cols: "3"
          },
          {
            name: "acceptanceActDetail.batch",
            cols: "2"
          },
          {
            name: "routeMap.certificate.signedAt",
            search: "",
            cols: "1"
          }
        ],
        start_date: null,
        end_date: null,
        search: "",
        rows: 10,
        page: 1,
        order: "id",
        orderType: "asc"
      },
      items: [],
      totalItems: 0,
      totalPages: 0
    };
  },
  computed: {
    ...mapGetters(["isLoadingFinalProductSaleRegister"]),
    orderIcon: function() {
      let vm = this;

      return vm.headers.orderType == "asc" ? "▲" : "▼";
    },
    visiblePages() {
      const range = [];
      let vm = this;

      let start, end;

      if (vm.headers.page < Math.ceil(vm.tableOptions.maxVisibleButtons / 2)) {
        start = 1;

        if (vm.tableOptions.maxVisibleButtons > vm.totalPages) {
          end = vm.totalPages;
        } else {
          end = vm.tableOptions.maxVisibleButtons;
        }
      } else if (
        vm.headers.page + Math.ceil(vm.tableOptions.maxVisibleButtons / 2) >
        vm.totalPages
      ) {
        start = vm.totalPages - vm.tableOptions.maxVisibleButtons + 1;
        end = vm.totalPages;
      } else {
        start =
          vm.headers.page - Math.floor(vm.tableOptions.maxVisibleButtons / 2);
        end =
          vm.headers.page + Math.floor(vm.tableOptions.maxVisibleButtons / 2);
      }

      for (let i = start; i <= end; i += 1) {
        range.push({
          name: i,
          isDisabled: i === vm.headers.page
        });
      }

      return range;
    }
  },
  watch: {
    "headers.start_date": _.debounce(function() {
      let vm = this;

      vm.headers.page = 1;

      if (!vm.startLoading) {
        vm.fetchData();
      }
    }, 250),
    "headers.end_date": _.debounce(function() {
      let vm = this;

      vm.headers.page = 1;

      if (!vm.startLoading) {
        vm.fetchData();
      }
    }, 250),
    "headers.search": _.debounce(function() {
      let vm = this;

      vm.fetchData();
    }, 250),
    "headers.rows": _.debounce(function(new_value) {
      let vm = this;
      new_value = parseInt(new_value);
      window.localStorage.setItem(vm.action + "_rows", new_value);

      vm.headers.page = 1;
      vm.fetchData();
    }, 250),
    "headers.page": _.debounce(function() {
      let vm = this;
      vm.fetchData();
    }, 250)
  },
  mounted() {
    let vm = this;

    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title:
          this.$t("REGISTER_OF_CERTIFICATE_OF_RELEASE_FOR_THE_SALE_OF_FINAL_PRODUCT")
      }
    ]);

    vm.fetchData();
  },
  methods: {
    dateFormat: function(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    getOptions: function() {
      let vm = this;

      vm.headers.order =
        window.localStorage.getItem(vm.action + "_order") || "id";
      vm.headers.orderType =
        window.localStorage.getItem(vm.action + "_orderType") || "asc";
      vm.headers.rows = parseInt(
        window.localStorage.getItem(vm.action + "_rows") || 10
      );
    },
    changeOrder: _.debounce(function(key) {
      let vm = this;

      if (vm.headers.order == key) {
        let oType = vm.headers.orderType == "asc" ? "desc" : "asc";

        vm.headers.orderType = oType;
      } else {
        vm.headers.order = key;
      }

      vm.headers.page = 1;
      window.localStorage.setItem(vm.action + "_order", vm.headers.order);
      window.localStorage.setItem(
        vm.action + "_orderType",
        vm.headers.orderType
      );

      vm.fetchData();
    }, 250),
    getSearchPayload: function() {
      return {
        search: this.headers.search,
        start_date: this.headers.start_date,
        end_date: this.headers.end_date
      };
    },
    fetchData: _.debounce(function() {
      let vm = this;

      vm.$store
        .dispatch(GET_ALL_FINAL_PRODUCT_SALE_REGISTER, { payload: vm.headers })
        .then(data => {
          vm.$nextTick(function() {
            vm.items = data.data.data;
            vm.totalItems = data.data.recordsTotal;
            vm.totalPages = data.data.totalPages;
            vm.startLoading = false;
          });
        })
        .catch(response => {
          if (response.status === 404) {
            vm.$notification["success"]({
              message: response.status,
              description: response.message
            });
            vm.$router.push({ name: "dashboard" });
          }
        });
    }, 500),
    downloadData: _.debounce(function() {
      let vm = this;

      vm.$store
        .dispatch(DOWNLOAD_FINAL_PRODUCT_SALE_REGISTER)
        .then(data => {
          let payload = vm.getSearchPayload();

          window.open(
            API_URL +
              `final-product-sale/export/${data.data.code}?search=${payload.search}&start_date=${payload.start_date}&end_date=${payload.end_date}&language=${localStorage.getItem("language") || "bg"}`
          );
        })
        .catch(response => {
          if (response.status === 404) {
            vm.$notification["success"]({
              message: response.status,
              description: response.message
            });
            vm.$router.push({ name: "dashboard" });
          }
        });
    }, 500)
  }
};
</script>
